import React from "react";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import {
    NoEthereumProviderError
} from "@web3-react/injected-connector";
import { useEffect, useState } from "react";
import { injected, walletconnect, coinbaseWallet } from "../hooks/connectors";
import Modal from 'react-bootstrap/Modal';
import { DEFAULT_CHAIN } from '../hooks/constant';
import useEagerConnect from '../hooks/useWeb3';
import metamaskIcon from '../assets/img/metamask.svg';
import coinbaseIcon from '../assets/img/coinbase.svg';
import walletconnectIcon from '../assets/img/walletconnect.svg';
import localStorage from "local-storage";


export const Connect = function () {
    const context = useWeb3React();
    const { connector, account, activate, deactivate, active, error } = context;
    const [show, setShow] = useState(false);


    useEffect(() => {
        if (account) {
            localStorage.set('address', account);
        }
    }, [account])


    // handle logic to recognize the connector currently being activated
    const [activatingConnector, setActivatingConnector] = useState();
    useEagerConnect();
    useEffect(() => {
        if (activatingConnector && activatingConnector === connector) {
            setActivatingConnector(undefined);
        }
    }, [activatingConnector, connector]);


    function getErrorMessage(error) {

        if (error instanceof NoEthereumProviderError) {
            const dappUrl = window.location.href; // TODO enter your dapp URL. 
            let metamaskAppDeepLink = "https://metamask.app.link/dapp/" + dappUrl;
            window.open(metamaskAppDeepLink)
        }
        if (error instanceof UnsupportedChainIdError) {
            return <span className="btn-text" onClick={(e) => switchNetwork(DEFAULT_CHAIN)}>Switch Network</span>;
        }

        deactivate(injected);
    }

    const activating = (connection) => connection === activatingConnector;
    const connected = (connection) => connection === connector;

    const switchNetwork = (networkid) => {
        try {
            // @ts-ignore
            window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: `0x${networkid.toString(16)}` }]
            });
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <React.Fragment>


            {
                error &&
                <button type="button" className="right-4 mint-button third connect-btn" onClick={() => {
                    setActivatingConnector();
                }}>
                    {getErrorMessage(error)}
                </button>
            }
            {!error &&
                <>


                    {active && (connected(injected) || connected(walletconnect) || connected(coinbaseWallet)) &&
                        <button type="button" className="connect-btn right-4 mint-button third connect-btn" onClick={() => {
                            setActivatingConnector();
                            deactivate(injected);
                            deactivate(walletconnect);
                            deactivate(coinbaseWallet);
                            localStorage.remove('address');
                        }}>Disconnect
                        </button>
                    }
                    {!active && (!connected(injected) || !connected(walletconnect) || !connected(coinbaseWallet)) &&
                        <button type="button" className="connect-btn right-4 mint-button third connect-btn" onClick={() => {
                            setShow(!show);
                        }}>
                            {(activating(injected) || activating(walletconnect) || activating(coinbaseWallet)) && <span className="btn-text">Connecting...</span>}
                            {(!activating(injected) || !activating(walletconnect) || !activating(coinbaseWallet)) && <span className="btn-text">Connect Wallet</span>}

                        </button>
                    }
                </>
            }


            <Modal
                show={show}
                onHide={() => setShow(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Connect wallet</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div class="wallets-container svelte-11upx36">

                        <div id="A" class="card left-half">
                            <button class="relative justify-start modal-btn svelte-ucnmri" onClick={() => {
                                    activate(injected);
                                    setShow(false);
                                }}>
                                <div class="relative svelte-1wcty06 border-blue background-transparent" >
                                    <div class="icon flex justify-center items-center svelte-1wcty06">
                                        <img src={metamaskIcon} alt="metamask img" height="25px" width="40px" />
                                    </div>
                                </div>
                                <span class="name svelte-ucnmri">Metamask</span>
                            </button>
                        </div>
                        <div id="B" class="card right-half">
                            <button class="relative justify-start modal-btn svelte-ucnmri" onClick={() => {
                                    activate(coinbaseWallet);
                                    setShow(false);
                                }}>
                                <div class="relative svelte-1wcty06 border-blue background-transparent" >
                                    <div class="icon flex justify-center items-center svelte-1wcty06">
                                        <img src={coinbaseIcon} height="25px" width="40px" alt="trutwallet img" />
                                    </div>
                                </div>
                                <span class="name svelte-ucnmri">Coinbase</span>
                            </button>
                        </div>
                        <div id="A" class="card left-half">
                            <button class="relative justify-start  modal-btn svelte-ucnmri" onClick={() => {
                                    activate(walletconnect);
                                    setShow(false);
                                }}>
                                <div class="relative svelte-1wcty06 border-blue background-transparent">
                                    <div class="icon flex justify-center items-center svelte-1wcty06">

                                        <img src={walletconnectIcon} height="25px" width="40px" alt="binance img" />
                                    </div>
                                </div>
                                <span class="name svelte-ucnmri">WalletConnect</span>
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>


        </React.Fragment >
    );
};

export default Connect;